import Api from "@/api"
import Storage from "@/utils/storage"
import sessionToken from "@/utils/session-token"
import { clearSession } from "@/utils/session-teardown"

let loggingOut = false

export const auth = {
  namespaced: true,
  state: {
    status: "",
    token: "",
    user: {},
    permissions: [],
    permissionsFetched: false,
    permissionsVersion: null
  },
  getters: {
    isLoggedIn: (state) => state.token != null && state.token !== "",
    authStatus: (state) => state.status,
    profileComplete: (state) => state.user.profile_complete || false,
    emailRequired: (state, getters) => getters.isLoggedIn && Boolean(state.user?.email_required),
    isGuest: (state, _getters, _rootState, rootGetters) =>
      (state.token == null || state.token === "") &&
      Boolean(rootGetters["global/isGuestBrowsingEnabled"]),
  },
  actions: {
    init({ commit }, data) {
      commit("init", data)
    },
    async setToken({ commit }, data) {
      const heldUser = JSON.parse(await Storage.get("user"))
      if (heldUser?.id && heldUser.id !== data.attributes.user.id) await clearSession()
      commit("loginSuccess", data)
      this.commit("global/clearStore")
    },
    login({ commit, dispatch }, args) {
      const type = args.type

      let api_service = null

      if (type == "google") {
        api_service = Api.googleLogin
      } else if (type == "apple") {
        api_service = Api.appleLogin
      }

      return api_service(args).then(
        async (resp) => {
          if (resp.data.challenge) return resp.data.challenge
          await dispatch("setToken", resp.data.data)
        },
        (error) => {
          commit("loginFailure")
          return Promise.reject(error)
        }
      )
    },
    async logout({ commit }) {
      if (loggingOut) return
      loggingOut = true
      await clearSession()
      commit("logout")
      window.location.replace("/login")
    },
    setUser({ commit }, data) {
      commit("setUser", data)
    },
    setUserAdmin({ commit }, data) {
      commit("setUserAdmin", data)
    },
    setLocale({ commit }, data) {
      commit("setLocale", data)
    },
    fetchPermissions( { commit , state}) {
      if(state.permissionsFetched) {
        return
      }

      return Api.fetchPermissions().then(({ data }) => {
        commit("fetchPermissions", data)
      })
    },
    fetchNewPermissions( { commit }) {
      return Api.fetchPermissions().then(({ data }) => {
        commit("fetchPermissions", data)
      })
    }
  },
  mutations: {
    loginRequest(state) {
      state.status = "loading"
    },
    init(state, data) {
      state.token = data.token
      state.user = data.user
    },
    async loginSuccess(state, data) {
      state.status = "success"
      state.token = data.attributes.jwt
      state.user = data.attributes.user
      this.state.global.pushTokenCommitted = false
      await sessionToken.set(state.token)
      await Storage.set("user", JSON.stringify(state.user))
    },
    async setUser(state, data) {
      state.user = data
      await Storage.set("user", JSON.stringify(state.user))
    },
    loginFailure(state) {
      state.status = "error"
      state.user = null
    },
    logout(state) {
      state.status = ""
      state.token = ""
      state.user = {}
    },
    async setUserAdmin(state, data) {
      state.user = Object.assign(state.user, { admin: data })
      await Storage.set("user", JSON.stringify(state.user))
    },
    async setLocale(state, data) {
      state.user = Object.assign(state.user, { locale: data })
      await Storage.set("user", JSON.stringify(state.user))
    },
    fetchPermissions(state, data) {
      state.permissionsVersion = data.version
      state.permissions = data.permissions
      state.permissionsFetched = true
    },
  },
}
